
import { Fragment, useEffect } from "react";

import { useStore } from "../../hook-store/store";


export default function IsAuthSet(props) {

  const { isAuth } = props;

  const [store, dispatch] = useStore();

  useEffect(() => {
    if (isAuth) {
      dispatch('SET_ISAUTH', true);
    } else {
      dispatch('SET_ISAUTH', false);
    }
  }, [isAuth]);



  return (
    <Fragment>
    </Fragment>
  )
}